import { render, staticRenderFns } from "./pravacy.vue?vue&type=template&id=0eaf9029&scoped=true&"
import script from "./pravacy.vue?vue&type=script&lang=js&"
export * from "./pravacy.vue?vue&type=script&lang=js&"
import style0 from "./pravacy.vue?vue&type=style&index=0&id=0eaf9029&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eaf9029",
  null
  
)

export default component.exports